import React, { useEffect, useRef } from 'react';
import { Animated, Easing, Platform } from 'react-native';
import { styles } from '../../utils/style';
const Styles = {
    ske: styles({
        backgroundColor: '#f2f2f2',
    }),
};
export function Skeleton(props) {
    const { style = {}, width, height = 30 } = props;
    const aniRef = useRef(new Animated.Value(1));
    useEffect(() => {
        // 滚动到Item后，有个闪烁的动画
        Animated.loop(Animated.sequence([
            Animated.timing(aniRef.current, {
                toValue: 0.5,
                duration: 800,
                easing: Easing.linear,
                useNativeDriver: Platform.OS !== 'web',
            }),
            Animated.timing(aniRef.current, {
                toValue: 1,
                duration: 800,
                easing: Easing.linear,
                useNativeDriver: Platform.OS !== 'web',
            }),
        ])).start();
    }, []);
    return (React.createElement(Animated.View, { style: [
            Styles.ske,
            {
                opacity: aniRef.current,
            },
            style,
            styles({
                width,
                height,
            }),
        ] }));
}
export default Skeleton;
